const context = [
    "SUMMARY","RULES"
];

export default context
